import React from 'react'
import { LuGlobe, LuMessageSquare, LuPhone, LuShare2 } from 'react-icons/lu'

export interface DirectReferralSourceOption {
  label: string
  icon: React.ReactNode
}

// Where a direct lead came in from, as an adviser logging one picks it. The
// label is what's stored as the referral's direct lead source.
export const directReferralSourceOptions: DirectReferralSourceOption[] = [
  { label: 'WhatsApp', icon: <LuMessageSquare /> },
  { label: 'Social Media', icon: <LuShare2 /> },
  { label: 'Phone', icon: <LuPhone /> },
  { label: 'Website', icon: <LuGlobe /> },
]
